import React from 'react';

const SKELETON_COUNT = 8;

function ProductsSkeleton(): React.JSX.Element {
  return (
    <div
      className="skeleton-grid"
      aria-busy="true"
      aria-label="Loading products"
    >
      {Array.from({ length: SKELETON_COUNT }).map((_, i): React.JSX.Element => (
        <div key={i} className="skeleton-card">
          <div className="skeleton-image" />
          <div className="skeleton-line skeleton-line--brand" />
          <div className="skeleton-line skeleton-line--title" />
          <div className="skeleton-line skeleton-line--price" />
        </div>
      ))}
    </div>
  );
}

export default ProductsSkeleton;
